import { render, staticRenderFns } from "./add_special.vue?vue&type=template&id=09ac7f0b&scoped=true&"
import script from "./add_special.vue?vue&type=script&lang=js&"
export * from "./add_special.vue?vue&type=script&lang=js&"
import style0 from "./add_special.vue?vue&type=style&index=0&id=09ac7f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ac7f0b",
  null
  
)

export default component.exports